export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: 'Tableau de bord',
					root: true,
					alignment: 'left',
					page: 'tableaudebord',
					icon: 'fa fa-home',
				},
				{
					title: 'Clients',
					root: true,
					alignment: 'left',
					page: 'clients',
					icon: 'fa fa-user-tag',
				},
				{
					title: 'Commissions',
					root: true,
					alignment: 'left',
					page: 'commissions',
					icon: 'fa fa-seedling',
				},
				{
					title: 'Support',
					root: true,
					alignment: 'left',
					page: 'tickets',
					icon: 'fa fa-headset',
				},
			]
		},
		aside: {
			self: {},
			items: []
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
